import {
  getCurrencySymbol,
  getFormattedNumber,
  sanitizeNumberValue,
} from '@vestigas/utils';

export type NumberDisplayProps = {
  readonly classNameValue?: string;
  readonly currency?: string;
  readonly digits?: 'auto' | number;
  readonly fallbackValue?: string;
  readonly forceSign?: boolean;
  readonly highContrast?: boolean;
  readonly locale?: string;
  readonly unit?: string;
  readonly value: number | string | undefined;
} & ComponentStyling;

export type FormattedNumberPresentation = {
  readonly formattedValue: string;
  readonly hasNoValue: boolean;
  readonly numericValue: number | undefined;
  readonly unitToRender: string | undefined;
};

export function getFormattedNumberPresentation({
  currency,
  digits = 'auto',
  fallbackValue = '—',
  forceSign = false,
  locale,
  unit,
  value,
}: NumberDisplayProps): FormattedNumberPresentation {
  const numericValue = sanitizeNumberValue(value);
  const formattedValue = getFormattedNumber({
    digits,
    fallbackValue,
    forceSign,
    locale,
    value: numericValue,
  });

  return {
    formattedValue,
    hasNoValue: numericValue === undefined,
    numericValue,
    unitToRender: currency ? getCurrencySymbol(currency, { locale }) : unit,
  };
}
